// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"e5924fae","667":"3f09872a","977":"5a41613e"}[chunkId] + ".chunk.js";
};